import React from 'react';
import _merge from 'lodash/merge';
import { getContext, useCombinedRefs } from 'common';

import Styled from 'components/Carousel/styles';

export interface CoachmarkPaginationIndicatorProps extends React.ComponentPropsWithRef<'div'> {
  /** If true, CoachmarkPaginationIndicator will be selected */
  selected?: boolean;
  /** Auto focuses on the indicator when it is selected. */
  autoFocus?: boolean;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/** CoachmarkPaginationIndicator component. All other props than `selected` will be provided to the root DOM element. */
const CoachmarkPaginationIndicator = React.forwardRef<HTMLElement, CoachmarkPaginationIndicatorProps>((props: CoachmarkPaginationIndicatorProps, ref) => getContext(({ RTL, theme }) => {
  const {
    selected,
    autoFocus,
    theme: themeProp,
    ...otherProps
  } = props;

  const resolvedTheme = _merge({}, theme ? theme.CAROUSEL : {}, themeProp);
  const containerRef = React.useRef(null);
  const combinedRef = useCombinedRefs(ref, containerRef);

  // autofocuses on selected CoachmarkPaginationIndicator indicator
  React.useEffect(() => {
    (autoFocus && selected) && combinedRef && combinedRef.current && combinedRef.current.focus();
  }, []);

  return (
    <Styled.CarouselIndicator
      ref={combinedRef}
      $rtl={RTL}
      $theme={resolvedTheme}
      selected={selected}
      tabIndex="0"
      role="button"
      {...otherProps}
    />
  );
}));

CoachmarkPaginationIndicator.defaultProps = {
  selected: false,
  autoFocus: true,
  theme: {}
};

CoachmarkPaginationIndicator.displayName = 'CoachmarkPaginationIndicator';

export default CoachmarkPaginationIndicator;
